import * as React from "react";
import Dropdown from "../../utils/dropdown";
import { config } from "../../../config/domain";
import {
	IPersonalDetails,
	IClientProfilePicture,
	ICOMPersonalDetails,
	ICOMServicingDetails,
	IServicingDetails
} from "../../types/components/login/userDetails";
import LoginService from "../../service/login/loginService";
import { Link } from "react-router-dom";
interface KeyType {
	[key: string]: any;
}

interface IUserListProps {}
interface IClientDetailsProps extends IUserListProps {
	userDeatils?: KeyType;
}

// toc nav list and component start
export const tocList = [
	{
		link: config.rootUrl + "?ottype=place-order",
		text: "place order",
		subText: "Stocks, Mutual Funds, SIPs, Currency etc.",
		id: "tc1"
	},
	{
		id: "tc2",
		subList: [
			{
				link: config.rootUrl + "?ottype=order-status",
				text: "Order Status",
				subText: "",
				id: "tc21"
			},
			{
				link: config.rootUrl + "?ottype=my-positions",
				text: "My Positions",
				subText: "",
				id: "tc22"
			}
		]
	},
	{
		id: "tc3",
		subList: [
			{
				link: config.rootUrl + "?ottype=see-margin",
				text: "Funds Available",
				subText: "",
				id: "tc31"
			},
			{
				link: config.rootUrl + "?ottype=fund-transfer",
				text: "Transfer Funds",
				subText: "",
				id: "tc32"
			}
		]
	},
	{
		id: "tc4",
		subList: [
			{
				link: config.rootUrl + "?ottype=see-holdings",
				text: "See Holdings",
				subText: "",
				id: "tc41"
			},
			{
				link: config.rootUrl + "watchlist",
				text: "My Watchlist",
				subText: "",
				id: "tc42"
			},
			{
				link: config.rootUrl + "alerts",
				text: "My Alerts",
				subText: "",
				id: "tc43"
			},
			{
				link: config.rootUrl + "?ottype=see-margin",
				text: "Margin Files",
				subText: "",
				id: "tc44"
			}
		]
	}
];
export function TocList(props: IUserListProps) {
	const tocListCont = {
		header: "BUY / SELL",
		list: (
			<>
				<ul className="dd-list">
					{tocList.map((item: any) => (
						<li className="dd-list-item" key={item.id}>
							{item.link && (
								<a href={item.link} className="listlink  dBlock">
									<label className="bold dBlock">{item.text}</label>
									{item.subText && <span className="sText ib">{item.subText}</span>}
								</a>
							)}
							{item.subList &&
								item.subList.map((sItem: any) => (
									<a href={sItem.link} className="listlink dBlock" key={sItem.id}>
										<label className="dBlock">{sItem.text}</label>
										{sItem.subText && <span>{sItem.subText}</span>}
									</a>
								))}
						</li>
					))}
				</ul>
			</>
		)
	};
	return (
		<Dropdown
			headerTitle={tocListCont.header}
			arrow={false}
			class="UserListDD ib mg-l20 showOnOver"
			selectItem={false}
			listCont={tocListCont.list}
			onClickTgl={false}
		/>
	);
}
// toc nav list and component end
// rreports nav list and component start

export const reportsList = [
	{
		link: config.rootUrl + "reports",
		text: "account overview",
		subText: "View your portfolio overview",
		id: "rp1"
	},
	{
		id: "rp2",
		subList: [
			{
				link: config.rootUrl + "historicalperformance",
				text: "Historical Performance",
				subText: "",
				id: "rp21"
			},
			{
				link: config.rootUrl + "transaction-history/equity",
				text: "Transaction History",
				subText: "",
				id: "rp22"
			},
			{
				link: config.rootUrl + "gps/dashboard",
				text: "Guided Portfolios Dashboard",
				subText: "",
				id: "rp23"
			},
			{
				link: config.rootUrl + "reports?true",
				text: "More Reports",
				subText: "",
				id: "rp24"
			}
		]
	}
];

export function ReportsList(props: IUserListProps) {
	const reportsListCont = {
		header: (
			<>
				<span className="dim">MY</span> REPORTS
			</>
		),
		list: (
			<>
				<ul className="dd-list">
					{reportsList.map((item: any) => (
						<li className="dd-list-item" key={item.id}>
							{item.link && (
								<a href={item.link} className="listlink  dBlock">
									<label className="bold dBlock">{item.text}</label>
									{item.subText && <span className="sText ib">{item.subText}</span>}
								</a>
							)}
							{item.subList &&
								item.subList.map((sItem: any) => (
									<a href={sItem.link} className="listlink dBlock" key={sItem.id}>
										<label className="dBlock">{sItem.text}</label>
										{sItem.subText && <span>{sItem.subText}</span>}
									</a>
								))}
						</li>
					))}
				</ul>
			</>
		)
	};
	return (
		<Dropdown
			headerTitle={reportsListCont.header}
			arrow={false}
			class="UserListDD reportsList ib mg-l20 showOnOver"
			selectItem={false}
			listCont={reportsListCont.list}
			onClickTgl={false}
		/>
	);
}
// rreports nav list and component end

// clientDetails nav list and component start

export function ClientDetails(props: IClientDetailsProps) {
	type IAccType = "EQ" | "CO" | "COMEQ";

	let PersonalDetails: IPersonalDetails & ICOMPersonalDetails = props.userDeatils ? props.userDeatils.personalDetails : {},
		ClientProfile: IClientProfilePicture = props.userDeatils ? props.userDeatils.clientPicture : {},
		ServicingDetails: IServicingDetails & ICOMServicingDetails = props.userDeatils ? props.userDeatils.servicingDetails : {};
	const lAccType: IAccType = (LoginService.getAccData("accTyp") as IAccType) || "EQ";
	const [accType, setaccType] = React.useState<IAccType>(lAccType !== "COMEQ" ? lAccType : "EQ");

	const ClientProfileCont = {
		header: (
			<label className="clientImg">
				{ClientProfile ? (
					<img alt="clientPicture" src={ClientProfile.ProfileImageByte} />
				) : (
					<span className="userPic">
						<i className="edel-icon-user "></i>
					</span>
				)}
			</label>
		),
		ddCont: (
			<>
				<div className="f0">
					<div className="left_block vTop">
						<label className="listHeader">LATEST UPDATES</label>
						<ul className="dd-list">
							<li className="listItem dd-list-item mg-b25">
								<a className="listlink dBlock ucase" href={`${config.rootUrl}clientarea/messages`}>
									MESSAGE CENTER
								</a>
								<span className="sText">No new messages for you</span>
							</li>
							<li className="listItem dd-list-item">
								<a className="listlink dBlock ucase" href={`${config.rootUrl}clientarea/servicerequest`}>
									SERVICE REQUEST
								</a>
								<span className="sText">No pending service requests for you</span>
							</li>
						</ul>
					</div>

					<div className="right_block vTop">
						<div className="acc-types mg-b10">
							<ul>
								<li className={accType === "EQ" ? "active" : ""} onClick={() => setaccType("EQ")}>
									<button>Equity</button>
								</li>
								<li className={accType === "CO" ? "active" : ""} onClick={() => setaccType("CO")}>
									<button>Commodities</button>
								</li>
							</ul>
						</div>
						<ul className="dd-list">
							<li className="listItem dd-list-item">
								{/* EQUITY COMMODITIES */}
								<label className="uname mg-b10">{PersonalDetails && (PersonalDetails.nameField || PersonalDetails.NAME)}</label>
								<div>
									<label className="listLabel dBlock">YOUR ADVISOR</label>
									<label className="uname dBlock">
										<i className="edel-icon-user"></i>
										{ServicingDetails && (ServicingDetails.equityAdvisorNameField || ServicingDetails.EQUITY_ADVISOR_NAME)}
									</label>
									{ServicingDetails && (
										<a
											href={`mailto:${ServicingDetails.equityAdvisorEmailField || ServicingDetails.EQUITY_ADVISOR_EMAIL}`}
											className="listlink "
										>
											<i className="edel-icon-email-us"></i>
											{ServicingDetails && (ServicingDetails.equityAdvisorEmailField || ServicingDetails.EQUITY_ADVISOR_EMAIL)}
										</a>
									)}
									<label className="listValue dBlock">
										<i className="edel-icon-call1"></i>
										{ServicingDetails &&
											(ServicingDetails.equityAdvisorContactNumberField || ServicingDetails.EQUITY_ADVISOR_CONTACT_NO)}
									</label>
								</div>
							</li>
							<li className="listItem dd-list-item">
								<a href={`${config.rootUrl}/clientarea`} className="listlink">
									<i className="edel-icon-user "></i>See Profile
								</a>
							</li>
							<li className="listItem dd-list-item">
								<Link to="/" className="listlink" onClick={LoginService.logout}>
									Logout
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</>
		)
	};
	return (
		<Dropdown
			headerTitle={ClientProfileCont.header}
			arrow={false}
			class="UserListDD ib mg-l20 clientDetails"
			selectItem={false}
			listCont={ClientProfileCont.ddCont}
		/>
	);
}

// clientDetails nav list and component end

export default TocList;
